import axios from "axios";
import { ShowError } from "../gui_components/UIComponents.js";
export class ServiceExecutorProxy{
    constructor() {}

    static executeService(methodName, input,data_url,responseCallBack, errorCallBack){
    const isFormData = input instanceof FormData;
        axios({
        method: "post",
        url: data_url + "/" + methodName,
        data: input,
        headers: {
          securitykey: localStorage.getItem("security_token"),
          Accept: "application/json",
          // "Content-Type": "application/json",
           ...(isFormData ? {} : { "Content-Type": "application/json" })
        },
      })
       .then((response) => {
          responseCallBack(response);
        })
        .catch((error) => {
          errorCallBack(error);
          ShowError("Erro : " + error);
        });
    }
    }